import ArrowRight from './assets/arrow-right.svg';
import ArrowLeft from './assets/arrow-left.svg';
import Document from './assets/document.svg';
import Video from './assets/video.svg';
import ChevronRight from './assets/chevron-right.svg';
import ChevronLeft from './assets/chevron-left.svg';
import ChevronUp from './assets/chevron-up.svg';
import ChevronDown from './assets/chevron-down.svg';
import ChevronRightSmall from './assets/chevron-right-small.svg';
import ChevronLeftSmall from './assets/chevron-left-small.svg';
import ChevronUpSmall from './assets/chevron-up-small.svg';
import ChevronDownSmall from './assets/chevron-down-small.svg';
import Support from './assets/support.svg';
import Plus from './assets/plus.svg';
import Checkmark from './assets/checkmark.svg';
import Close from './assets/close.svg';
import Fuel from './assets/fuel.svg';
import Electric from './assets/electric.svg';
import CheckmarkForms from './assets/checkmark-forms.svg';
import CircleCheckbox from './assets/circle-checkbox.svg';
import Lock from './assets/lock.svg';
import ChevronWhite from './assets/chevron-white.svg';
import Logo from './assets/logo.svg';
import CheckmarkSmall from './assets/checkmark-small.svg';
import Info from './assets/info.svg';
import NavLeft from './assets/nav-left.svg';
import NavRight from './assets/nav-right.svg';
import DoubleArrows from './assets/double-arrows.svg';
import Minus from './assets/minus.svg';
import Play from './assets/play.svg';
import Paus from './assets/paus.svg';
import Copy from './assets/copy.svg';

export const Icons = {
  ArrowRight,
  ArrowLeft,
  Document,
  Video,
  ChevronRight,
  ChevronLeft,
  ChevronUp,
  ChevronDown,
  ChevronRightSmall,
  ChevronLeftSmall,
  ChevronUpSmall,
  ChevronDownSmall,
  Support,
  Plus,
  Checkmark,
  Close,
  Fuel,
  Electric,
  CheckmarkForms,
  CircleCheckbox,
  Lock,
  ChevronWhite,
  Logo,
  CheckmarkSmall,
  Info,
  NavLeft,
  NavRight,
  DoubleArrows,
  Minus,
  Play,
  Paus,
  Copy,
};

// eslint-disable-next-line no-redeclare
export type Icons = keyof typeof Icons;
